<template>
    <!-- Road cyclist, flat white; only the jersey takes the team colour.
         Ground contact is the bottom centre of the viewBox (see
         themes/index.js for the rider contract). -->
    <svg class="theme-rider rider-cycling" :class="{ 'rider-moving': moving }" viewBox="0 0 64 44" :width="size" :height="size * 44 / 64" aria-hidden="true">
        <g class="rider-wheel" style="transform-origin: 13px 33px">
            <circle cx="13" cy="33" r="9.5" />
            <path d="M13 23.5v19M3.5 33h19" />
        </g>
        <g class="rider-wheel" style="transform-origin: 51px 33px">
            <circle cx="51" cy="33" r="9.5" />
            <path d="M51 23.5v19M41.5 33h19" />
        </g>
        <path class="rider-frame" d="M13 33 L29 33 L24 18.5 Z M24 18.5 L44 18 L29 33 M44 18 L51 33 M21 18 L27 18 M44 18 L47.5 17 Q51 18 49 22.5" />
        <path class="rider-limb rider-limb-back" d="M24 16 L30 23 L26.5 29.5" />
        <path class="rider-accent-edge" d="M24 16.5 L39 11" />
        <path class="rider-accent" :style="{ stroke: color }" d="M24 16.5 L39 11" />
        <path class="rider-limb" d="M24 16 L33.5 22.5 L32 38" />
        <path class="rider-limb rider-arm" d="M39 11 L43 14.5 L47.5 17.5" />
        <circle class="rider-head" cx="43.6" cy="7.6" r="3.1" />
    </svg>
</template>

<script>
export default {
    name: 'CyclingRider',
    props: {
        color: { type: String, default: '#00a7af' },
        size: { type: Number, default: 56 },
        moving: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
    svg{ overflow: visible; }
    circle, path{
        fill: none;
        stroke: #fff;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    .rider-wheel circle{ stroke-width: 2.6; }
    .rider-wheel path{ stroke-width: 1; opacity: 0.7; }
    .rider-frame{ stroke-width: 2.4; }
    .rider-limb{ stroke-width: 3.4; }
    .rider-limb-back{ opacity: 0.6; }
    .rider-arm{ stroke-width: 2.8; }
    /* Thin dark edge so a white (or very light) team colour still reads. */
    .rider-accent-edge{ stroke: rgba(0, 0, 0, 0.45); stroke-width: 9; }
    .rider-accent{ stroke-width: 7.4; }
    .rider-head{ fill: #fff; stroke: none; }
    .rider-moving .rider-wheel{ animation: rider-spin 0.45s linear infinite; }
    @keyframes rider-spin{ to{ transform: rotate(360deg); } }
    @media (prefers-reduced-motion: reduce){
        .rider-moving .rider-wheel{ animation: none; }
    }
</style>
